import { useEffect, useMemo, useState } from 'react';
import { DEFAULT_EXPERIENCE_COVER_IMAGE } from '../../../shared/lib/defaultImages';

function urlFallbackChain(src: string): string[] {
  const t = (src ?? '').trim();
  if (!t) return [DEFAULT_EXPERIENCE_COVER_IMAGE];
  if (t === DEFAULT_EXPERIENCE_COVER_IMAGE) return [t];
  return [t, DEFAULT_EXPERIENCE_COVER_IMAGE];
}

type Props = {
  src: string;
  alt: string;
  className?: string;
  loading?: 'lazy' | 'eager';
  draggable?: boolean;
  title?: string;
};

/** `<img>` que tenta `src` e, em erro (ex.: 404 em GET /api/media), usa capa padrão. */
export function ImageWithMediaFallback({ src, alt, className, loading, draggable, title }: Props) {
  const chain = useMemo(() => urlFallbackChain(src), [src]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    setIdx(0);
  }, [src]);

  const url = chain[Math.min(idx, chain.length - 1)] ?? DEFAULT_EXPERIENCE_COVER_IMAGE;

  return (
    <img
      src={url}
      alt={alt}
      title={title}
      className={className}
      loading={loading}
      draggable={draggable}
      onError={() => setIdx((i: number) => (i + 1 < chain.length ? i + 1 : i))}
    />
  );
}
